// You can write more code here

/* START OF COMPILED CODE */

import Phaser from "phaser";
/* START-USER-IMPORTS */
import { GameDataHandler } from '../GameDataHandler';
import { RelicName , RelicNameValues } from "../level/relics/relic";
/* END-USER-IMPORTS */

export default class Scoreboard extends Phaser.GameObjects.Container {

  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 100, y ?? 45);

    // holder_gems_png
    const holder_gems_png = scene.add.image(5, -1, "common", "holder-gems.png");
    this.add(holder_gems_png);

    // score
    const score = scene.add.bitmapText(0, -8, "arco", "0");
    score.setOrigin(0.5, 0.5);
    score.text = "0";
    score.fontSize = 75;
    score.align = 1;
    this.add(score);

    // carrot_png
    const carrot_png = scene.add.image(-130, -7, "common", "icon-gems.png");
    this.add(carrot_png);

    // relicShadow
    const relicShadow = scene.add.image(141, 3, "game-all", "slot-boots.png");
    relicShadow.scaleX = 0.4;
    relicShadow.scaleY = 0.4;
    this.add(relicShadow);

    // relicImage
    const relicImage = scene.add.image(137, -1, "game-all", "relic-boots.png");
    relicImage.scaleX = 0.4;
    relicImage.scaleY = 0.4;
    this.add(relicImage);

    this.score = score;
    this.relicShadow = relicShadow;
    this.relicImage = relicImage;

    /* START-USER-CTR-CODE */
    this.on(Phaser.GameObjects.Events.DESTROY, () => {
      this.scene.registry.events.off(GameDataHandler.events.ChangeScore, this.onScoreChange, this);
    });
    this.scene.registry.events.on(GameDataHandler.events.ChangeScore, this.onScoreChange, this);
    /* END-USER-CTR-CODE */
  }

  private score: Phaser.GameObjects.BitmapText;
  private relicShadow: Phaser.GameObjects.Image;
  private relicImage: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  public create(scene: Phaser.Scene) {}

  public showScoreboard() {
    this.setVisible(true);
    this.alpha = 0;

    this.scene.add.tween({
      targets: this,
      alpha: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  public showRelic(relicName: RelicNameValues) {

    let key:string = 'game-all';
    switch (relicName) {
      case RelicName.BronzeBoots:
        this.relicImage.setTexture(key, "relic-boots.png");
        this.relicShadow.setTexture(key, "slot-boots.png");
        break;
        case RelicName.GoldenWings:
          this.relicImage.setTexture(key, "relic-wings.png");
        this.relicShadow.setTexture(key, "slot-wings.png");
        break;
          case RelicName.SilverHelmet:
            this.relicImage.setTexture(key, "relic-helmet.png");
            this.relicShadow.setTexture(key, "slot-helmet.png");
            break;
          case RelicName.PlatinumMagnet:
            this.relicImage.setTexture(key, "relic-magnet.png");
            this.relicShadow.setTexture(key, "slot-magnet.png");
            break;
          case RelicName.DiamondSkull:
            this.relicImage.setTexture(key, "relic-skull.png");
            this.relicShadow.setTexture(key, "slot-skull.png");
            break;
      default:
        this.relicImage.visible=false;
        this.relicShadow.visible=false;
        break;
    }
  }

  public hideRelic(){
    this.relicImage.visible=false;
    this.relicShadow.visible=false;
  }


  public hideScoreboard() {
    this.scene.add.tween({
      targets: this,
      alpha: 0,
      duration: 250,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: () => this.setVisible(false)
    });
  }

  protected onScoreChange(parent: any, value: any, previousValue: any) {
    this.score.text = value;
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
